import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { AlterRowTransformation } from 'app/model/dataflow/alterrowtransformation';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AlterRowTransformation),
    asynchronous: true
})
export class AlterRowTransformationAdapter extends TransformationAdapter<AlterRowTransformation> {
    public async getDslScript(alterRowTransformation: AlterRowTransformation): Promise<string> {
        const props: string[] = [];
        alterRowTransformation.ifConditions
            .filter((ifCondition) => !!ifCondition.action && !!ifCondition.conditionExpression.expression)
            .forEach((ifCondition) => {
                props.push(`${ifCondition.action}(${ifCondition.conditionExpression.expression})`);
            });

        const partition = TransformationAdapter.getPartitionDslScript(alterRowTransformation);
        if (partition) {
            props.push(partition);
        }

        const knownProps = props.join(',\n\t');
        const unknownProps = this._getUnknownProps(alterRowTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(alterRowTransformation)}` +
            ` ${AlterRowTransformation.MODEL.name}(${transformationData}) ${FLOW} ${this._getOutputStreams(
                alterRowTransformation
            )}`
        );
    }
}
